import React, { useState } from 'react';

const FAQ = () => {
  const [activeIndex, setActiveIndex] = useState(null);

  const faqs = [
    {
      question: 'How do I create an itinerary with jetsetai?',
      answer: 'To create an itinerary with jetsetai, simply input your destination, travel dates, and preferences, and our AI will generate a personalized itinerary for you.'
    },
    {
      question: 'Is jetsetai free to use?',
      answer: 'Yes, jetsetai is completely free to use. You can create unlimited itineraries and access all features without any cost.'
    },
    {
      question: 'How accurate are the recommendations provided by jetsetai?',
      answer: " jetsetai utilizes Meta's Llama-3 AI to analyze your destination, travel dates, and preferences to generate a personalized itinerary tailored to your needs and interests."
    },
    {
      question: 'What is the maximum duration for itinerary generation?',
      answer: 'jetsetai can generate itineraries for a maximum duration of 7 days.'
    },
    {
      question: 'What types of travel preferences does jetsetai accommodate?',
      answer: 'jetsetai can accommodate various travel preferences, including activities, accommodations, transportation modes, dietary restrictions, and more. Simply input your preferences, and JetSetAI will tailor the itinerary accordingly.'
    }
  ];

  const toggleAccordion = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  return (
    <div className="max-w-3xl mt-12 mx-auto px-4 sm:px-6 lg:px-8">
      <h3 className="mb-4 mt-0 text-3xl font-medium leading-tight text-gray-700 text-center text-primary">
        Frequently Asked Questions
      </h3>
      <div className="space-y-4 mb-4">
        {faqs.map((faq, index) => (
          <div key={index} className="border rounded-lg overflow-hidden shadow-md">
            <button
              className="flex justify-between items-center w-full py-4 px-6 bg-white text-left focus:outline-none"
              onClick={() => toggleAccordion(index)}
            >
              <span className="font-semibold">{faq.question}</span>
              <span className={`transform ${activeIndex === index ? 'rotate-180' : 'rotate-0'} transition-transform duration-300`}>
                &#x2B;
              </span>
            </button>
            {activeIndex === index && (
              <div className="px-6 py-4 bg-gray-50">
                <p className="text-gray-700">{faq.answer}</p>
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default FAQ;
